var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoWine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22499 14.375V13.175H7.39999V10.0437C6.32499 9.88125 5.46249 9.4 4.81249 8.6C4.16249 7.8 3.83749 6.85 3.83749 5.75V1.625H12.1625V5.75C12.1625 6.85 11.8375 7.8 11.1875 8.6C10.5375 9.4 9.67499 9.88125 8.59999 10.0437V13.175H10.775V14.375H5.22499ZM7.99999 8.88125C8.73749 8.88125 9.36874 8.65 9.89374 8.1875C10.4312 7.7125 10.7687 7.1 10.9062 6.35H5.09374C5.23124 7.1 5.56249 7.7125 6.08749 8.1875C6.62499 8.65 7.26249 8.88125 7.99999 8.88125ZM5.03749 5.15H10.9625V2.825H5.03749V5.15Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWine);
export default __webpack_public_path__ + "static/media/ico_wine.98d844f69a36d3700b81e664273bac3d.svg";
export { ForwardRef as ReactComponent };